<nav id="sidebar" class="sidebar-main">
    <div class="sidebar-inner">
        <!-- Sidebar toggle -->
    <div class="sidebar-toggle-main">
        <button (click)="toggleSideBar()" id="sidebarCollapse" class="btn toggle-sidebar-btn" style="padding-top: 4px;">
          <i [ngClass]="isSidebarButtonToggled ? 'pi-angle-double-right' : 'pi-angle-double-left'" class="pi"></i>
        </button>
      </div>

       <!-- Sidebar Header -->
    <div class="sidebar-header">      
        <a class="sidebar-logo-container" href="#">
          <img class="sidebar-logo" alt="logo" src="../../../assets/images/logos/vetrotech_tesca_logo.png" alt="" />
        </a>    
    </div> 

       <!-- Sidebar Menu List -->
       <!-- <div class="menubar">
        <ul class="list-unstyled components">
            <li class="list-tests menu-item primary-list">
                <a routerLink="admin/standard" routerLinkActive="active" class="menulink">
                  <span class="menu-icon">
                    <svg viewBox="94 1 15 16">
                      <use xlink:href="../../assets/images/icons/menu-icons.svg#iconCertificate"></use>
                    </svg>
                  </span>
                  <span class="fa fa-lg site_sidebar-main_icon site_sidebar-main_link--admin"></span>
                  <span class="menulink-text">Admin</span>
                  <span class="fa fa-lg fa-caret-left site_sidebar-main_down-icon"></span>
                </a>
              </li>
        </ul>
       </div> -->

       <div class="site_sidebar-main">
        <nav class="nav flex-column site_sidebar-main_nav">
            <a class="nav-link site_sidebar-main_link" data-bs-target="#pageSubmenu" data-bs-toggle="collapse" aria-expanded="true">
                <span class="fa fa-lg site_sidebar-main_icon site_sidebar-main_link--admin"></span>
                <span class="">Master</span>
                <span class="fa fa-lg fa-caret-left site_sidebar-main_down-icon" style="padding: 10px;"></span>
            </a>          
            
            <div class="collapse submenu" id="pageSubmenu">
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/beadPosition" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Bead Position</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/certificatetype" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Certificate Type</span>
                </a>
                 <a class="nav-link site_sidebar-main_link" routerLink="/admin/projectConfidentiality" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Confidentiality Level</span>
                </a>
                 <a class="nav-link site_sidebar-main_link" routerLink="/admin/componentCausedFailure" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Component Caused Failure</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/costType" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Cost Type</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/constructionElementType" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Construction Element Type</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/country" routerLinkActive="active">
                   <span class="site_sidebar-main_link-title">Country</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/frame" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Frame Mapping</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/frameName" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Frame Name</span>
                 </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/frameMaterial" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Frame Material</span>
                 </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/glassCoatingCode" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Glass Coating Code</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/glassManufacturer" #user="routerLinkActive" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Glass Manufacturer</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/glassType" routerLinkActive="active">
                   <span class="site_sidebar-main_link-title">Glass Type</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/glassUnit" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Glass Unit</span>
                </a>
                <!-- <a class="nav-link site_sidebar-main_link" routerLink="/admin/group" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Group</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/groupType" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Group Type</span>
                </a> -->
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/institute" routerLinkActive="active">
                   <span class="site_sidebar-main_link-title">Institute</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/instituteType" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Institute Type</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/mountingDirection" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Mounting Direction</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/glassBehavior" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Glass Behavior</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/organisationalUnit" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Organisational Unit</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/projectOwnerType" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Owner Type</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/partner" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Partner</span>
                </a>
                <!-- <a class="nav-link site_sidebar-main_link" routerLink="/admin/partnerType" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Partner Type</span>
                </a> -->
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/performanceCriteria" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Performance Criteria</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/projectPurpose" routerLinkActive="active">
                   <span class="site_sidebar-main_link-title">Purpose</span>
                </a>
                 <a class="nav-link site_sidebar-main_link" routerLink="/admin/result-failure" routerLinkActive="active">
                   <span class="site_sidebar-main_link-title">Result Failure Reason</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/resultUnit" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Result Unit</span>
                </a>
               
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/projectStatus" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Status</span>
                </a>
                <!-- <a class="nav-link site_sidebar-main_link" routerLink="/admin/region" routerLinkActive="active">
                   <span class="site_sidebar-main_link-title">Region</span>
                </a> -->
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/standard" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Standard</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/supportingConstruction" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Supporting Construction</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/testPurpose" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Test Purpose</span>
                </a>
                <a class="nav-link site_sidebar-main_link" routerLink="/admin/testType" routerLinkActive="active">
                    <span class="site_sidebar-main_link-title">Test Type</span>
                </a>
            </div>
        </nav>
       </div>

    </div>
</nav>





